import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import Carousel from 'react-material-ui-carousel';

import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const About = () => {
  const [open, setOpen] = useState(false);
  const images = [
    {
      label: (
        <React.Fragment>
          TaxZerone is the best e-file service I have ever used. The interface
          is user-friendly, and the step-by-step instructions make the process
          easy to follow.{' '}
          <Stack
            direction="row"
            spacing={1}
            sx={{ mt: 2 }}
            justifyContent={{ xs: 'center', md: 'center' }}
          >
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-1"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-2"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-3"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-4"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-5"
            />
          </Stack>
        </React.Fragment>
      ),
    },
    {
      label: (
        <React.Fragment>
          I&apos;m so glad I found TaxZerone! Filing Form 7004 for my business
          has always been a headache, but TaxZerone makes it so much easier.{' '}
          <Stack
            direction="row"
            spacing={1}
            sx={{ mt: 2 }}
            justifyContent={{ xs: 'center', md: 'center' }}
          >
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-1"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-2"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-3"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-4"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-5"
            />
          </Stack>
        </React.Fragment>
      ),
    },
    {
      label: (
        <React.Fragment>
          I was skeptical at first about using an e-file service for my personal
          tax extension, but TaxZerone exceeded my expectations. The process was
          straightforward and seamless.{' '}
          <Stack
            direction="row"
            spacing={1}
            sx={{ mt: 2 }}
            justifyContent={{ xs: 'center', md: 'center' }}
          >
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-1"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-2"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-3"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-4"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-5"
            />
          </Stack>
        </React.Fragment>
      ),
    },
    {
      label: (
        <React.Fragment>
          TaxZerone is a lifesaver! The step-by-step instructions were so easy
          to follow, and I received my approval letter immediately.{' '}
          <Stack
            direction="row"
            spacing={1}
            sx={{ mt: 2 }}
            justifyContent={{ xs: 'center', md: 'center' }}
          >
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-1"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-2"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-3"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-4"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-5"
            />
          </Stack>
        </React.Fragment>
      ),
    },
    {
      label: (
        <React.Fragment>
          The interface is intuitive and easy to navigate. Plus, their customer
          service team is always available to help with any questions or
          concerns. I highly recommend TaxZerone!{' '}
          <Stack
            direction="row"
            spacing={1}
            sx={{ mt: 2 }}
            justifyContent={{ xs: 'center', md: 'center' }}
          >
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-1"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-2"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-3"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-4"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-5"
            />
          </Stack>
        </React.Fragment>
      ),
    },
    {
      label: (
        <React.Fragment>
          I just wanted to take a moment to express what a great conversation I
          had with the support agent via the chat platform. He was very
          attentive and resolved my issue. Also, very patient and kind!
          Excellent service!{' '}
          <Stack
            direction="row"
            spacing={1}
            sx={{ mt: 2 }}
            justifyContent={{ xs: 'center', md: 'center' }}
          >
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-1"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-2"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-3"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-4"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-5"
            />
          </Stack>
        </React.Fragment>
      ),
    },
  ];

  return (
    <AppLayout
      meta={
        <Meta
          title="About TaxZerone® | E-filing IRS Federal Tax Forms"
          description="Discover TaxZerone - your trusted partner for seamless e-filing of IRS federal tax forms. Learn more about our commitment to simplifying your tax journey."
          keywords="TaxZerone, IRS Tax Filing Software, IRS-authorized provider, Excise Taxes, Employment Taxes, Tax-Exempt Forms, Tax Extension Forms"
          canonical="about-us/"
        />
      }
    >
      <ComingSoonPopup open={open} setOpen={setOpen} />
      <Container maxWidth="xl">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                <span className="highlight-container">
                  <span className="highlight">IRS-Authorized</span>
                </span>{' '}
                Tax E-filing Solution Provider
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                TaxZerone provides a secure, accurate, and efficient online tax
                filing service for businesses, individuals, truckers, and
                nonprofit organizations. As an IRS-authorized e-filing solution,
                we ensure that your tax forms are filed with the IRS seamlessly.
              </Typography>
              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Button
                  variant="contained"
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=about`}
                  sx={{
                    mr: { xs: 0, md: 4 },
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                >
                  E-file Now
                </Button>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      mb: { xs: '0 !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/irs-authorized.webp" />
                      <source srcSet="/assets/images/irs-authorized.png" />
                      <Box
                        component="img"
                        src="/assets/images/irs-authorized.png"
                        loading="lazy"
                        alt="IRS-authorized e-file provider"
                        width={70}
                        height={69}
                        sx={{
                          width: { xs: 50, md: 70 },
                          height: { xs: 49, md: 69 },
                        }}
                      />
                    </picture>
                  </Box>
                  <Box
                    sx={{
                      mb: { xs: '0px !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/tzo-soc2.webp" />
                      <source srcSet="/assets/images/tzo-soc2.png" />
                      <Box
                        component="img"
                        src="/assets/images/tzo-soc2.png"
                        loading="lazy"
                        alt="TZO SOC2 Compliant"
                        width={90}
                        height={89}
                        sx={{
                          width: { xs: 70, md: 90 },
                          height: { xs: 69, md: 89 },
                        }}
                      />
                    </picture>
                  </Box>
                </Stack>
              </Stack>
            </Box>
          </Box>
          <Hidden smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
              className="banner-bg"
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/about-img.webp" />
                <source srcSet="/assets/images/about-img.png" />
                <img
                  src="/assets/images/about-img.png"
                  alt="IRS-authorized Tax E-filing Solution Provider"
                  loading="lazy"
                  width={660}
                  height={544}
                  className="img-responsive-banner"
                />
              </picture>
            </Box>
          </Hidden>
          {/* <Hidden lgUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
              className="banner-bg"
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/about-img-sm.webp"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <source
                  srcSet="/assets/images/about-img-sm.png"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <img
                  src="/assets/images/about-img-sm.png"
                  alt="IRS-authorized Tax E-filing Solution Provider"
                  className="img-responsive-banner"
                  loading="lazy"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden> */}
        </Stack>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          overflow: 'hidden',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ py: { xs: 0, sm: 2, md: 10 } }}>
          {/* <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={5}
            mb={{ xs: 0, sm: 0 }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} >
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                About Us
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 0,
                  textAlign: 'center',
                }}
              >
                TaxZerone is created by a team of tax-product experts with more
                than 15 years of experience.
                <Hidden mdDown>
                  <br />
                </Hidden>{' '}
                With the aim of simplifying the complex tax filing process,
                TaxZerone helps
                <Hidden mdDown>
                  <br />
                </Hidden>{' '}
                businesses, individuals, truckers, and nonprofit organizations
                to file tax forms online with the IRS quickly and securely.
              </Typography>
            </Grid>
          </Grid> */}
          {/* Our Mission section start */}
          <Stack
            direction={{ xs: 'column-reverse', md: 'row' }}
            sx={{
              mt: { xs: 0, md: 0 },
              mb: { xs: 0, md: 5 },
              ml: { xs: 0, lg: 0, xl: 0 },
              borderRadius: 5,
              '& img': {
                width: { xs: '100%', md: 'auto' },
                height: { xs: '100%', md: 'auto' },
                maxWidth: 459,
                maxHeight: 420,
                boxShadow: '0px 0px 50px rgba(91,98,117,.2)',
                borderRadius: 6,
              },
            }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
              }}
            >
              <picture>
                <source srcSet="/assets/images/mission-img.webp" />
                <source srcSet="/assets/images/mission-img.png" />
                <img
                  src="/assets/images/mission-img.png"
                  alt="Our Mission"
                  //  className="img-responsive img-shadow"
                  loading="lazy"
                  width={459}
                  height={420}
                />
              </picture>
            </Box>
            <Box sx={{ mt: { xs: 0, md: 0 } }}>
              <Stack
                direction={{ xs: 'row', sm: 'row' }}
                spacing={2}
                sx={{
                  mr: 0,
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  mb: 2,
                  mt: 5,
                  px: { xs: 2, sm: 2, md: 3 },
                  pb: { xs: 2, sm: 2, md: 3 },
                  pt: { xs: 0, sm: 0, md: 3 },
                  // backgroundColor: '#fff',
                  minHeight: { xs: '100%', md: '79%', lg: '79%' },
                  borderTopRightRadius: 16,
                  borderBottomRightRadius: 16,
                  borderTopLeftRadius: { xs: 16, md: 0 },
                  borderBottomLeftRadius: { xs: 16, md: 0 },
                }}
              >
                <Box sx={{ px: { xs: 2, md: 5 } }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 30, md: 26, sm: 24, xs: 20 },
                      fontWeight: 600,
                      mb: 0,
                      textAlign: 'left',
                      lineHeight: 1.5,
                    }}
                  >
                    <span className="highlight-container">
                      <span className="highlight">Our Mission</span>
                    </span>{' '}
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    At TaxZerone, our team of tax product experts with over 15
                    years of experience is dedicated to simplifying the complex
                    tax filing process. Our goal is to help businesses,
                    individuals, truckers, and nonprofit organizations file
                    their tax forms quickly and securely online with the IRS.
                  </Typography>
                </Box>
              </Stack>
            </Box>
          </Stack>
          {/* Our Mission section end */}

          {/* Our Story section start */}
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            sx={{
              mt: { xs: 0, md: 0 },
              mb: { xs: 0, md: 5 },
              mr: { xs: 0, lg: 0, xl: 0 },
              borderRadius: 5,
              '& img': {
                width: { xs: '100%', md: 'auto' },
                height: { xs: '100%', md: 'auto' },
                maxWidth: 459,
                maxHeight: 420,
                boxShadow: '0px 0px 50px rgba(91,98,117,.2)',
                borderRadius: 6,
              },
            }}
          >
            <Box sx={{ mt: { xs: 0, md: 0 } }}>
              <Stack
                direction={{ xs: 'row', sm: 'row' }}
                spacing={2}
                sx={{
                  mr: 0,
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  mb: 2,
                  mt: 5,
                  px: { xs: 2, sm: 2, md: 3 },
                  pb: { xs: 2, sm: 2, md: 3 },
                  pt: { xs: 8, md: 3 },
                  // backgroundColor: '#fff',
                  minHeight: { xs: '100%', md: '79%', lg: '79%' },
                  borderTopLeftRadius: 16,
                  borderBottomLeftRadius: 16,
                  borderTopRightRadius: { xs: 16, md: 0 },
                  borderBottomRightRadius: { xs: 16, md: 0 },
                }}
              >
                <Box sx={{ px: { xs: 2, md: 5 } }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 30, md: 26, sm: 24, xs: 20 },
                      fontWeight: 600,
                      mb: 0,
                      textAlign: 'left',
                      lineHeight: 1.5,
                    }}
                  >
                    <span className="highlight-container">
                      <span className="highlight">Our Story</span>
                    </span>{' '}
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    We understand that tax filing is a cumbersome task and doing
                    it online without assistance can lead to time-consuming
                    errors and potential IRS penalties. That&apos;s why we
                    created TaxZerone - to make tax e-filing simple, quick, and
                    accurate. Our guided tax e-filing solution helps you
                    complete your tax filing on time and avoid penalties due to
                    inaccuracies.
                  </Typography>
                </Box>
              </Stack>
            </Box>
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
              }}
            >
              <picture>
                <source srcSet="/assets/images/story-img.webp" />
                <source srcSet="/assets/images/story-img.png" />
                <img
                  src="/assets/images/story-img.png"
                  alt="Our Story"
                  className="img-responsive img-shadow"
                  loading="lazy"
                  width={459}
                  height={420}
                />
              </picture>
            </Box>
          </Stack>
          {/* Our Story section end */}

          {/* Our Brand section start */}
          <Stack
            direction={{ xs: 'column-reverse', md: 'row' }}
            sx={{
              mt: { xs: 0, md: 0 },
              mb: { xs: 5, md: 5 },
              ml: { xs: 0, lg: 0, xl: 0 },
              borderRadius: 5,
              '& img': {
                width: { xs: '100%', md: 'auto' },
                height: { xs: '100%', md: 'auto' },
                maxWidth: 459,
                maxHeight: 420,
                boxShadow: '0px 0px 50px rgba(91,98,117,.2)',
                borderRadius: 6,
              },
            }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
              }}
            >
              <picture>
                <source srcSet="/assets/images/brand-img.webp" />
                <source srcSet="/assets/images/brand-img.png" />
                <img
                  src="/assets/images/brand-img.png"
                  alt="Our Brand"
                  className="img-responsive img-shadow"
                  loading="lazy"
                  width={459}
                  height={420}
                />
              </picture>
            </Box>
            <Box sx={{ mt: { xs: 0, md: 0 } }}>
              <Stack
                direction={{ xs: 'row', sm: 'row' }}
                spacing={2}
                sx={{
                  mr: 0,
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  mb: 2,
                  mt: 5,
                  px: { xs: 2, sm: 2, md: 3 },
                  pb: { xs: 2, sm: 2, md: 3 },
                  pt: { xs: 8, md: 3 },
                  // backgroundColor: '#fff',
                  minHeight: { xs: '100%', md: '79%', lg: '79%' },
                  borderTopRightRadius: 16,
                  borderBottomRightRadius: 16,
                  borderTopLeftRadius: { xs: 16, md: 0 },
                  borderBottomLeftRadius: { xs: 16, md: 0 },
                }}
              >
                <Box sx={{ px: { xs: 2, md: 5 } }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 30, md: 26, sm: 24, xs: 20 },
                      fontWeight: 600,
                      mb: 0,
                      textAlign: 'left',
                      lineHeight: 1.5,
                    }}
                  >
                    <span className="highlight-container">
                      <span className="highlight">Our Brand</span>
                    </span>{' '}
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0 }}>
                    At TaxZerone, we redefine the tax filing experience by
                    making it simple, secure, and affordable. Our brand name
                    reflects our mission through three fundamental elements:
                  </Typography>
                  <List>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <span style={{ fontWeight: 600 }}>Tax:</span> Directly
                        represents our core service—providing expert assistance
                        with your taxes.
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <span style={{ fontWeight: 600 }}>Zero:</span>{' '}
                        Emphasizes our commitment to simplicity, stripping away
                        the complexities of tax filing to ensure a smooth and
                        effortless process.
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <span style={{ fontWeight: 600 }}>One:</span> Highlights
                        our focus on precision and efficiency. Just as ones and
                        zeros are the building blocks of the digital world,
                        TaxZerone is the foundation of a streamlined and
                        reliable tax filing experience.
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Stack>
            </Box>
          </Stack>
          {/* Our Brand section end */}

          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            justifyContent="space-between"
            alignItems="stretch"
            spacing={4}
            sx={{ mb: 10 }}
          >
            <Box
              sx={{
                width: '100%',
                backgroundColor: '#e2f8e2',
                p: 3,
                borderRadius: 4,
                border: '2px solid #333',
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  mt: 0,
                  textAlign: 'left',
                }}
              >
                Embracing the Binary Connection
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 2,
                  textAlign: 'left',
                }}
              >
                Inspired by binary code <b>(0 and 1)</b>, TaxZerone symbolizes
                the fundamental elements of the digital age. We aim to be your
                essential partner, transforming tax filing into a stress-free
                and straightforward process.
              </Typography>
            </Box>
            <Box
              sx={{
                width: '100%',
                backgroundColor: '#dff7fb',
                p: 3,
                borderRadius: 4,
                border: '2px solid #333',
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  mt: 0,
                  textAlign: 'left',
                }}
              >
                Pronunciation
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 2,
                  textAlign: 'left',
                }}
              >
                Our name TaxZerone is pronounced as <br />
                <Box
                  component="span"
                  sx={{
                    fontSize: { lg: 24, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                  }}
                >
                  &quot;Tax Zee-roan&quot;
                </Box>
                ,
                <br /> reflecting the ease and modernity we bring to tax filing.
              </Typography>
            </Box>
          </Stack>

          <Typography
            variant="h2"
            //  color="white"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 3,
              mt: 0,
              textAlign: 'center',
            }}
          >
            Our Brand Promise
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
              fontWeight: 400,
              color: '#333333',
              mb: 3,
              textAlign: 'center',
            }}
          >
            Making Tax Filing Simple, Secure, and Affordable
            <br />
            This promise reflects our core values:
          </Typography>
          <Grid
            container
            spacing={2}
            m={2}
            pb={{ xs: 0, sm: 5 }}
            className="MuiGrid-root-width"
            sx={{ justifyContent: 'center' }}
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 2,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 10,
                  height: '100%',
                  boxShadow: '10px 0px 30px rgba(91,98,117,.15)',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 96,
                    height: 96,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source srcSet="/assets/images/easy-icon.webp" />
                    <source srcSet="/assets/images/easy-icon.png" />
                    <img
                      src="/assets/images/easy-icon.png"
                      alt="Simplicity"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Simplicity
                </Typography>
                <Typography variant="body1">
                  We design our platform with user-friendliness at the
                  forefront, ensuring an intuitive and hassle-free tax filing
                  experience.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 2,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 10,
                  height: '100%',
                  boxShadow: '10px 0px 30px rgba(91,98,117,.15)',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 96,
                    height: 96,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source srcSet="/assets/images/secure-icon.webp" />
                    <source srcSet="/assets/images/secure-icon.png" />
                    <img
                      src="/assets/images/secure-icon.png"
                      alt="Security"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Security
                </Typography>
                <Typography variant="body1">
                  We prioritize the protection of your personal information,
                  implementing advanced security measures to safeguard your
                  data.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 2,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 10,
                  height: '100%',
                  boxShadow: '10px 0px 30px rgba(91,98,117,.15)',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 96,
                    height: 96,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source srcSet="/assets/images/lowest-icon.webp" />
                    <source srcSet="/assets/images/lowest-icon.png" />
                    <img
                      src="/assets/images/lowest-icon.png"
                      alt="Affordability"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Affordability
                </Typography>
                <Typography variant="body1">
                  We believe professional tax assistance should be accessible to
                  all, offering our services at competitive prices.
                </Typography>
              </Paper>
            </Grid>
          </Grid>

          {/* Our Products section start */}
          <Stack
            direction={{ xs: 'column', md: 'row', lg: 'row' }}
            sx={{
              mt: { xs: 0, md: 10 },
              mb: { xs: 5, md: 5 },
              mr: { xs: 0, lg: 0, xl: 0 },
              borderRadius: 5,
              '& img': {
                width: { xs: '100%', md: 'auto' },
                height: { xs: '100%', md: 'auto' },
                maxWidth: 459,
                maxHeight: 420,
                boxShadow: '0px 0px 50px rgba(91,98,117,.2)',
                borderRadius: 6,
              },
            }}
          >
            <Box sx={{ mt: { xs: 0, md: 0 } }}>
              <Stack
                direction={{ xs: 'row', sm: 'row' }}
                spacing={2}
                sx={{
                  mr: 0,
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  mb: 2,
                  mt: 2.5,
                  px: { xs: 2, sm: 2, md: 3 },
                  pb: { xs: 2, sm: 2, md: 3 },
                  pt: { xs: 5, sm: 0, md: 3 },
                  // backgroundColor: '#fff',
                  minHeight: { xs: '100%', md: '79%', lg: '79%' },
                  borderTopLeftRadius: 16,
                  borderBottomLeftRadius: 16,
                  borderTopRightRadius: { xs: 16, md: 0 },
                  borderBottomRightRadius: { xs: 16, md: 0 },
                }}
              >
                <Box sx={{ px: { xs: 2, md: 5 } }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 30, md: 26, sm: 24, xs: 20 },
                      fontWeight: 600,
                      mb: 0,
                      textAlign: 'left',
                      lineHeight: 1.5,
                    }}
                  >
                    <span className="highlight-container">
                      <span className="highlight">Supported Forms</span>
                    </span>{' '}
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0 }}>
                    With TaxZerone, businesses, individuals, and nonprofit
                    organizations can e-file tax forms with the IRS. Currently,
                    we support the filing of IRS forms under the following
                    categories:
                  </Typography>
                  <List>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link
                          href="/information-returns/"
                          sx={{ color: '#0202ff', fontWeight: 600 }}
                        >
                          Information Returns
                        </Link>{' '}
                        - <small>W-2, 1099, 1098, 1095 Forms</small>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link
                          href="/employment-tax/"
                          sx={{ color: '#0202ff', fontWeight: 600 }}
                        >
                          Employment Tax Forms
                        </Link>{' '}
                        -{' '}
                        <small>
                          941, 941-X, 941 Schedule R, 940, 943, 943-X, 944, 945,
                          945-X 94X PIN Request
                        </small>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link
                          href="/tax-extension/"
                          sx={{ color: '#0202ff', fontWeight: 600 }}
                        >
                          Extension Forms
                        </Link>{' '}
                        - <small>7004, 4868, 8868</small>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link
                          href="/tax-exempt/"
                          sx={{ color: '#0202ff', fontWeight: 600 }}
                        >
                          Exempt Org. Forms
                        </Link>{' '}
                        -{' '}
                        <small>
                          990-N, 990-EZ, 990, 990-PF, 990-T, 5227, CA 199
                        </small>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link
                          href="/excise-tax/"
                          sx={{ color: '#0202ff', fontWeight: 600 }}
                        >
                          Excise Tax Forms
                        </Link>{' '}
                        - <small>2290, 8849, 2290 Amendments</small>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link
                          href="/business-tax/"
                          sx={{ color: '#0202ff', fontWeight: 600 }}
                        >
                          Business Tax Forms
                        </Link>{' '}
                        - <small> 1120-S and 1065 Forms </small>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link
                          href="/efile-boi-report/"
                          sx={{ color: '#0202ff', fontWeight: 600 }}
                        >
                          FinCEN BOI Report
                        </Link>{' '}
                        - <small>BOIR</small>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link
                          href="/request-form-w9-online-free/"
                          sx={{ color: '#0202ff', fontWeight: 600 }}
                        >
                          Form W-9
                        </Link>{' '}
                        - <small>W-9 Forms</small>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Stack>
            </Box>
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
              }}
            >
              <picture>
                <source srcSet="/assets/images/products-img.webp" />
                <source srcSet="/assets/images/products-img.png" />
                <img
                  src="/assets/images/products-img.png"
                  alt="Our Products"
                  className="img-responsive img-shadow"
                  loading="lazy"
                  width={459}
                  height={420}
                />
              </picture>
            </Box>
          </Stack>
          {/* Our Products section end */}
        </Container>
      </Grid>

      <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
        <Grid
          container
          spacing={2}
          m={2}
          mt={{ xs: 5, sm: 5, md: 10 }}
          mb={{ xs: 5, sm: 5, md: 10 }}
          className="MuiGrid-root-width"
        >
          <Grid size={12} textAlign="center">
            <Stack
              direction="row"
              spacing={1}
              sx={{ mb: 2 }}
              justifyContent={{ xs: 'center', md: 'center' }}
            >
              <img
                src="/assets/images/star-icon.svg"
                width={30}
                height={28}
                alt="star-1"
              />
              <img
                src="/assets/images/star-icon.svg"
                width={30}
                height={28}
                alt="star-2"
              />
              <img
                src="/assets/images/star-icon.svg"
                width={30}
                height={28}
                alt="star-3"
              />
              <img
                src="/assets/images/star-icon.svg"
                width={30}
                height={28}
                alt="star-4"
              />
              <img
                src="/assets/images/star-icon.svg"
                width={30}
                height={28}
                alt="star-5"
              />
            </Stack>
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: { xs: 1, sm: 3 },
              }}
            >
              Hear what our customers have
              <Hidden smDown>
                <br />
              </Hidden>{' '}
              to say about us
            </Typography>

            <Carousel
              animation="fade"
              navButtonsAlwaysVisible
              indicatorIconButtonProps={{
                style: {
                  marginTop: '0px', // 5
                  textAlign: 'right', // 4
                  paddingBottom: '0px',
                  marginBottom: '0px',
                },
              }}
              className="carousel"
            >
              {images.map((step, index) => (
                <Box
                  component="div"
                  sx={{
                    p: 2,
                    textAlign: 'center',

                    borderRadius: 0,
                    backgroundColor: 'transparent',
                    borderWidth: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    mx: { xs: -2, sm: 'auto' },
                    maxWidth: 800,
                    minHeight: { xs: 200, sm: 170, md: 220 },
                  }}
                  key={index}
                >
                  <Typography
                    component="span"
                    sx={{
                      fontFamily: 'san-serif',
                      fontSize: { xs: 65, sm: 100 },
                      fontWeight: 600,
                      color: '#1da94a',
                      lineHeight: { xs: '30px', sm: '65px' },
                    }}
                  >
                    &ldquo;
                  </Typography>
                  <Typography
                    variant="body1"
                    component="div"
                    color="gray"
                    sx={{
                      fontSize: { xs: 18, sm: 22, md: 30 },
                      fontFamily: 'san-serif',
                      fontStyle: 'italic',
                      color: '#414042',
                      lineHeight: 1.2,
                    }}
                  >
                    {step.label}
                  </Typography>
                  <Typography
                    component="span"
                    sx={{
                      fontFamily: 'san-serif',
                      fontSize: { xs: 65, sm: 100 },
                      fontWeight: 600,
                      color: '#1da94a',
                      lineHeight: { xs: '30px', sm: '65px' },
                    }}
                  >
                    &rdquo;
                  </Typography>
                </Box>
              ))}
            </Carousel>
          </Grid>
        </Grid>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',

          mx: '0 !important',
          width: '100% !important',
          py: { xs: 1, sm: 3 },
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h2"
            //  color="white"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 3,
              mt: 3,
              textAlign: 'center',
            }}
          >
            Why Choose TaxZerone
          </Typography>
          <Grid
            container
            spacing={2}
            m={2}
            pb={5}
            className="MuiGrid-root-width"
            sx={{ justifyContent: 'center' }}
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 2,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 10,
                  height: '100%',
                  boxShadow: '10px 0px 30px rgba(91,98,117,.15)',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#1da94a',
                    borderRadius: '50%',
                    width: 96,
                    height: 96,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 62, height: 54 }}>
                    <source
                      srcSet="/assets/images/easy-white-icon.webp"
                      width={62}
                      height={54}
                    />
                    <source
                      srcSet="/assets/images/easy-white-icon.png"
                      width={62}
                      height={54}
                    />
                    <img
                      src="/assets/images/easy-white-icon.png"
                      alt="Easy to Use"
                      loading="lazy"
                      width={62}
                      height={54}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Easy to Use
                </Typography>
                <Typography variant="body1">
                  Follow our step-by-step instructions to e-file tax forms with
                  the IRS and get your returns accepted quickly.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 2,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 10,
                  height: '100%',
                  boxShadow: '10px 0px 30px rgba(91,98,117,.15)',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#1da94a',
                    borderRadius: '50%',
                    width: 96,
                    height: 96,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 62, height: 54 }}>
                    <source srcSet="/assets/images/irs-white-icon.webp" />
                    <source srcSet="/assets/images/irs-white-icon.png" />
                    <img
                      src="/assets/images/irs-white-icon.png"
                      alt="IRS-Authorized"
                      loading="lazy"
                      width={62}
                      height={54}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  IRS-Authorized
                </Typography>
                <Typography variant="body1">
                  File tax forms online with confidence in accuracy and security
                  as TaxZerone is an IRS-authorized tax e-filing solution.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 2,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 10,
                  height: '100%',
                  boxShadow: '10px 0px 30px rgba(91,98,117,.15)',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#1da94a',
                    borderRadius: '50%',
                    width: 96,
                    height: 96,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 62, height: 54 }}>
                    <source srcSet="/assets/images/time-white-icon.webp" />
                    <source srcSet="/assets/images/time-white-icon.png" />
                    <img
                      src="/assets/images/time-white-icon.png"
                      alt="Real-Time Updates"
                      loading="lazy"
                      width={62}
                      height={54}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Real-Time Updates
                </Typography>
                <Typography variant="body1">
                  Receive real-time updates on the return status as soon as the
                  IRS accepts it. Track your return status easily.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          // pt: 20,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Container maxWidth="lg">
          <Typography
            variant="h2"
            color="white"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              lineHeight: 1.5,
              mb: 3,
            }}
          >
            Our Commitment to You
          </Typography>

          <Typography
            variant="h3"
            sx={{
              fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
              fontWeight: 400,
              color: '#f3f3f3',
              lineHeight: 1.5,
              mb: 3,
            }}
          >
            TaxZerone represents our relentless dedication to providing a
            seamless and stress-free tax filing experience. We blend innovation
            with expertise to ensure your tax filing is not just a task but a
            simple and secure journey.
          </Typography>
          <Box component="div" sx={{ margin: 'auto' }}>
            <Button
              variant="contained"
              sx={{
                mt: { xs: 0, sm: 4 },
                mb: { xs: 0, md: 0 },
                color: '#444',
                transition: 'all 0.3s ease 0s',
                '&:hover, &active': {
                  backgroundColor: '#213e99 !important',
                  color: '#fff',
                  transform: 'scale(1.1)',
                },
              }}
              className="btn-secondary-white"
              href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=about`}
            >
              E-file Now
            </Button>
          </Box>
        </Container>
      </Box>
    </AppLayout>
  );
};

export default About;
